module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"monday":"M","tuesday":"T","wednesday":"W","thursday":"R","friday":"F","saturday":"S","sunday":"U","titleField":"Select one or more days of the weeks"},"es":{"monday":"L","tuesday":"M","wednesday":"X","thursday":"J","friday":"V","saturday":"S","sunday":"D","titleField":"Selecciona uno o varios de dias de la semana"}}')
  delete Component.options._Ctor
}
